export default function CsharpReturnValues() {
  return (
    <h2>Csharp Return Values</h2>
  );
}
